import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class SupportTicketsService {
  constructor(private http: HttpService) {}

  getSupportTickets(
    page: number = 1,
    page_size: number = 10,
    filters: any = {},
  ) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', page_size.toString());

    Object.entries(filters || {}).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        const filteredValues = value.filter(
          (item) => item !== null && item !== undefined && item !== '',
        );
        if (filteredValues.length) {
          params = params.delete(key);
          filteredValues.forEach((item) => {
            params = params.append(key, String(item));
          });
        }
        return;
      }

      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return new Promise((resolve, reject) => {
      this.http.get('support-ticket', params).subscribe(
        (resp: any) => resolve(resp),
        (error) => reject(error),
      );
    });
  }

  updateSupportTicket(ticketId: number, body: any) {
    return new Promise((resolve, reject) => {
      this.http.patch(`support-ticket/${ticketId}`, body).subscribe(
        (resp: any) => resolve(resp),
        (error) => reject(error),
      );
    });
  }

  getSupportTicket(ticketId: number) {
    return new Promise((resolve, reject) => {
      this.http.get(`support-ticket/${ticketId}`).subscribe(
        (resp: any) => resolve(resp),
        (error) => reject(error),
      );
    });
  }

  getSupportTicketMessages(ticketId: number) {
    return new Promise((resolve, reject) => {
      this.http.get(`support-ticket/${ticketId}/messages`).subscribe(
        (resp: any) => resolve(resp),
        (error) => reject(error),
      );
    });
  }

  addSupportTicketMessage(ticketId: number, body: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`support-ticket/${ticketId}/messages`, body).subscribe(
        (resp: any) => resolve(resp),
        (error) => reject(error),
      );
    });
  }

  escalateSupportTicket(ticketId: number, body: any = {}) {
    return new Promise((resolve, reject) => {
      this.http.post(`support-ticket/${ticketId}/escalate`, body).subscribe(
        (resp: any) => resolve(resp),
        (error) => reject(error),
      );
    });
  }

  createSupportTicket(body: any) {
    return new Promise((resolve, reject) => {
      this.http.post('support-ticket', body).subscribe(
        (resp: any) => resolve(resp),
        (error) => reject(error),
      );
    });
  }
}
